import React, { Component } from 'react'
import { connect } from 'react-redux'

import Icon from '../icon'

import './iconcycle.scss'

class IconCycle extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
  }

  render () {
    let selectedIndex = this.props.icons.findIndex(x => x.value === this.props.value)
    const onClick = () => {
      let nextIndex = selectedIndex + 1
      if (this.props.icons.length === nextIndex) nextIndex = 0
      this.props.onChange({ target: { type: 'cycle', name: this.props.name, value: this.props.icons[nextIndex].value } })
    }

    return (
      <div className='element-icon-scycle' onClick={onClick}>
        <Icon size={this.props.size} icon={this.props.icons[selectedIndex].icon} injectSvg />
      </div>
    )
  }
}

IconCycle.defaultProps = {
  size: 't',
  value: 0,
  onChange: null,
  name: '',
  icons: [] // should be an array of type: { icon: ElementIcons.Edit, value: 0 }
}

export default connect(null, {

})(IconCycle)
// export default AddButton



// WEBPACK FOOTER //
// ./src/app/shared/elements/iconCycle/index.js